export default __webpack_public_path__ + "static/cashflow_new_main-00aaf43d7e9f1ecfaf5f5f59c4d745f0.jpg";